import { useTheme } from '@mui/material/styles';
import { success } from '../../theme';
import { styleConstants } from '../../Utils/styleConsts';
export const useStyles = () => {
    const theme = useTheme();
    return {
        title: {
            color: theme.palette.primary.dark,
        },
        form: {
            display: 'flex',
            flexDirection: 'column',
            marginTop: theme.spacing(2),
            maxWidth: '26rem',
            backgroundColor: theme.palette.background.paper,
            borderRadius: styleConstants.borderRadius,
            paddingTop: theme.spacing(1),
            '& > *:not(hr)': {
                paddingLeft: theme.spacing(2),
                paddingRight: theme.spacing(2),
            },
            [theme.breakpoints.down('sm')]: {
                maxWidth: '100%',
                '& > *:not(hr)': {
                    paddingLeft: theme.spacing(1),
                    paddingRight: theme.spacing(1),
                },
            },
        },
        buttonContainer: {
            display: 'flex',
            marginTop: theme.spacing(2),
            gap: theme.spacing(2),
        },
        save: {
            flexGrow: 1,
            marginLeft: theme.spacing(1),
        },
        active: {
            backgroundColor: `${success.main} !important`,
            color: `${theme.palette.common.white} !important`,
            '&:hover': {
                backgroundColor: `${success.dark} !important`,
            },
        },
        breadcrumb: {
            display: 'flex',
            alignItems: 'center',
            color: theme.palette.primary.main,
        },
        breadcrumbText: {
            color: theme.palette.primary.dark,
            padding: '0 0 0.25em',
            lineHeight: '1em',
        },
        sent: {
            display: 'flex',
        },
        success: {
            marginRight: theme.spacing(1),
            color: success.main,
        },
        button: {
            textTransform: styleConstants.buttonTextTransform,
            fontSize: styleConstants.buttonFontSize,
            fontWeight: styleConstants.buttonFontWeight,
            padding: styleConstants.buttonPadding,
        },
        notVerified: {
            marginRight: theme.spacing(1),
        },
        newVerifictaionEmail: {
            padding: `0 !important`,
        },
        divider: {
            marginTop: theme.spacing(2),
            marginBottom: theme.spacing(2.5),
        },
    };
};
